<template>
	<div class="plugin-logs">
		<AppTable
			ref="logs-table"
			:filters="null"
			:fetch-function="fetchFunctionLogs"
			:table-headings="tableHeadingsLogs"
			:title="getString('plugin_logs')"
			:total-items="logsTotal"
			:items="logs"
			initial-sort-field="date" >
			<template #before-table>
				<p>{{ getString('plugin_logs_explain') }}</p>
			</template>
		</AppTable>
	</div>
</template>

<script>
import {useUserStore} from "@/console-new/stores";
import AppList from "@/shared/components/AppList.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppTable from "@/shared/components/AppTable.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import API from "@/shared/helpers/API";
import {getLocalDateFromServer} from "@/shared/helpers/dates";

export default {
	setup() {
		const userStore = useUserStore();
		const languageStore = useLanguageStore();
		const notificationStore = useNotificationStore();
		return {
			userStore,
			notificationStore,
			getString: languageStore.getString,
		};
	},
	name: "PluginLogs",
	components: {AppTable, ModalHeader, AppList},
	emits: ["close"],
	props: {
		pluginId: {type: Number, required: true},
	},
	data() {
		return {
			logs: [],
			logsTotal: 0,
		}
	},
	computed: {
		tableHeadingsLogs() {
			return [
				{
					text: this.getString('date'),
					cols: 1,
					sortable: true,
					fieldName: 'date',
				},
				{
					text: this.getString('type'),
					cols: 1,
					sortable: false,
					fieldName: 'outboundString',
				},
				{
					text: this.getString('duration'),
					cols: 1,
					sortable: false,
					fieldName: 'time_s',
				},
				{
					text: this.getString('url'),
					cols: 2,
					sortable: false,
					fieldName: 'url',
				},
				{
					text: this.getString('request'),
					cols: 3,
					fieldName: 'request',
				},
				{
					text: this.getString('response'),
					cols: 3,
					fieldName: 'response',
				},
			];
		},
	},
	methods: {
		fetchFunctionLogs(filters, callback) {

			if(!this.userStore.currBusinessId) { callback && callback(false); return; }

			API.init().getFilteredPluginLogs(this.userStore.currBusinessId, this.pluginId, JSON.stringify(filters || []), r => {
				this.logs = [];
				this.logsTotal = 0;
				if(r && r.result === "OK") {
					if(r.logs && r.logs.selected && r.logs.selected.length) {
						r.logs.selected.forEach(t => {
							this.logs.push(this.normalizeLog(t));
						});
						this.logsTotal = Number(r.logs.selected_num || 0);
					}
					if(callback) { callback(true); }
				} else {
					if(callback) { callback(false, r ? r.details : null); }
				}
			});

		},
		normalizeLog(log) {
			log.plugin_business_log_id = log.plugin_business_log_id ? Number(log.plugin_business_log_id) : null;
			log.time_s = log.time_s ? Number(log.time_s).toFixed(3)+"s" : null;
			log.outboundString = log.outbound === 1 ? 'sent' : 'received';
			log.date = log.date ? getLocalDateFromServer(log.date) : null;
			return log;
		},
	},
}
</script>

<style scoped lang="scss">

</style>